import { CircularProgress, Typography } from "@material-ui/core";
import { useEffect, useState } from "react";
import blitzService from "services/blitzService";

import ReceiptSteps from "./Step";
import { LoadingBlitzContent, PopupContent, StyledDialog } from "./style";

const STEPS_THAT_REQUIRE_BLITZ_RULE = ["quality_blitz", "weight_blitz"];

export const StepsPopup = ({
  openConfirm,
  handleCloseOpenSteps,
  batchData,
  reloadData
}) => {
  const [blitzData, setBlitzData] = useState();
  const [loadingBlitz, setLoadingBlitz] = useState(true);
  const [blitzRuleError, setBlitzRuleError] = useState(false);
  const [title, setTitle] = useState("Caixas");
  const workflowStep = batchData?.workflow?.currentStep;
  const hasBlitz = Boolean(batchData?.workflow?.hasBlitz);
  const requiresBlitzRule =
    hasBlitz && STEPS_THAT_REQUIRE_BLITZ_RULE.includes(workflowStep);

  const handleClose = () => {
    handleCloseOpenSteps();
    reloadData();
  };

  const getBlitzRule = async (productBaseId, batchId) => {
    try {
      setLoadingBlitz(true);
      setBlitzRuleError(false);
      setBlitzData(undefined);
      const { data } = await blitzService.getBlitzData({
        productBaseId,
        batchId
      });
      setBlitzData(data.results?.[0]);
    } catch (error) {
      setBlitzRuleError(true);
    } finally {
      setLoadingBlitz(false);
    }
  };

  useEffect(() => {
    openConfirm &&
      batchData.id &&
      getBlitzRule(batchData.product?.id, batchData.id);
  }, [openConfirm, batchData.id, batchData.confirmed_quantity]);

  const shouldBlockByBlitzRule =
    !loadingBlitz && requiresBlitzRule && !blitzData;

  return (
    <StyledDialog open={openConfirm} handleClose={handleClose} title={title}>
      <PopupContent>
        {loadingBlitz ? (
          <LoadingBlitzContent>
            <CircularProgress color="primary" />
          </LoadingBlitzContent>
        ) : shouldBlockByBlitzRule ? (
          <LoadingBlitzContent
            style={{ flexDirection: "column", padding: "1rem" }}
          >
            <Typography align="center" color="error">
              {blitzRuleError
                ? "Não foi possível carregar a regra de blitz."
                : "Regra de blitz não encontrada para esta etapa."}
            </Typography>
          </LoadingBlitzContent>
        ) : (
          <ReceiptSteps
            batchData={batchData}
            blitzData={blitzData}
            hasBlitz={hasBlitz}
            handleClose={handleClose}
            setTitle={setTitle}
          />
        )}
      </PopupContent>
    </StyledDialog>
  );
};
